<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/trade/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    let reportTypeList = {1:"额度调整-存取款",2:"额度调整-赠金送出"};
    let proposalStatusList = {0:"未审批",1:"已取消",2:"已审核"};
    export default {
        name: 'real',
        components: {
            tablePage,
            FORM,
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }
            },
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  //hasLable: true,
                  cols:[
                      { title: "交易账号", field: 'account'},
                      { title: "提案号", field: 'proposalNo'},
                      { title: "调整类型", field: 'reportType',type:2,optionList:reportTypeList},
                      {click:"查询"},
                      ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.balance.balanceRecord.demoQuery, //请求路径和参数
                    selection: false,
                    sequence: true,
                    cols: [
                        { title: "交易账号", field: 'account'},
                        { title: "平台", field: 'platform'},
                        { title: "提案号", field: 'proposalNo'},
                        { title: "记录类型", field: 'reportType',render:(data,full)=>{
                            return reportTypeList[data];
                        }},
                        { title: "账户币种", field: 'currency'},
                        { title: "调整金额", field: 'transAmount'},
                        { title: "加入时间", field: 'jointime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        { title: "支出", field: 'expenditure'},
                        { title: "收入", field: 'income'},
                        { title: "交易前额度", field: 'amountSrc'},
                        { title: "交易后额度", field: 'amountDst'},
                        { title: "备注", field: 'remark'},
                    ]
                }
            }
        }
    }
</script>

